import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';

const style = makeStyles(() => ({
  center: {
    textAlign: 'center',
    justifyContent: 'center',
  },
  chip: {
    width: '100%',
  },
}));

const RecommendedChecks = ({ data, setCheck }) => {
  const classes = style();

  return (
    <>
      <Grid item xs={12} className={classes.center}>
        <Chip
          className={classes.chip}
          variant={data.fast ? 'default' : 'outlined'}
          label={<FormattedMessage id="conversation.review.fast" defaultMessage="Fast response" />}
          clickable
          onClick={setCheck('fast')}
          color="primary"
        />
      </Grid>
      <Grid item xs={12} className={classes.center}>
        <Chip
          className={classes.chip}
          variant={data.friendly ? 'default' : 'outlined'}
          label={<FormattedMessage id="conversation.review.friendly" defaultMessage="Friendly treatment" />}
          clickable
          onClick={setCheck('friendly')}
          color="primary"
        />
      </Grid>
      <Grid item xs={12} className={classes.center}>
        <Chip
          className={classes.chip}
          variant={data.other ? 'default' : 'outlined'}
          label={<FormattedMessage id="conversation.review.otherreason" defaultMessage="Other reason" />}
          clickable
          onClick={setCheck('other')}
          color="primary"
        />
      </Grid>
    </>
  );
};

RecommendedChecks.propTypes = {
  data: PropTypes.shape({
    fast: PropTypes.bool,
    friendly: PropTypes.bool,
    other: PropTypes.bool,
  }).isRequired,
  setCheck: PropTypes.func.isRequired,
};

const NotRecommendedChecks = ({ data, setCheck }) => {
  const classes = style();

  return (
    <>
      <Grid item xs={12} className={classes.center}>
        <Chip
          className={classes.chip}
          variant={data.slow ? 'default' : 'outlined'}
          label={<FormattedMessage id="conversation.review.slow" defaultMessage="Slow response" />}
          clickable
          onClick={setCheck('slow')}
          color="primary"
        />
      </Grid>
      <Grid item xs={12} className={classes.center}>
        <Chip
          className={classes.chip}
          variant={data.calendar_outdated ? 'default' : 'outlined'}
          label={<FormattedMessage id="conversation.review.calendaroutdated" defaultMessage="Calendar not updated" />}
          clickable
          onClick={setCheck('calendar_outdated')}
          color="primary"
        />
      </Grid>
      <Grid item xs={12} className={classes.center}>
        <Chip
          className={classes.chip}
          variant={data.price_outdated ? 'default' : 'outlined'}
          label={<FormattedMessage id="conversation.review.wrongprice" defaultMessage="Price in ad was wrong" />}
          clickable
          onClick={setCheck('price_outdated')}
          color="primary"
        />
      </Grid>
      <Grid item xs={12} className={classes.center}>
        <Chip
          className={classes.chip}
          variant={data.other ? 'default' : 'outlined'}
          label={<FormattedMessage id="conversation.review.otherreason" defaultMessage="Other reason" />}
          clickable
          onClick={setCheck('other')}
          color="primary"
        />
      </Grid>
    </>
  );
};

NotRecommendedChecks.propTypes = {
  data: PropTypes.shape({
    slow: PropTypes.bool,
    calendar_outdated: PropTypes.bool,
    price_outdated: PropTypes.bool,
    other: PropTypes.bool,
  }).isRequired,
  setCheck: PropTypes.func.isRequired,
};

const Form = ({
  onSubmit, initialValues,
}) => {
  const { recommended } = initialValues;
  const [data, setData] = React.useState({
    ...initialValues.details,
    extra: initialValues.extra,
    other: !!initialValues.extra,
  });

  React.useEffect(() => {
    setData({
      ...initialValues.details,
      extra: initialValues.extra,
      other: !!initialValues.extra,
    });
  }, [initialValues]);

  const setCheck = (key) => () => setData({
    ...data,
    [key]: !data[key],
  });
  const setExtra = (e) => {
    const { value } = e.target;

    setData({
      ...data,
      extra: value || '',
    });
  };

  return (
    <Grid container spacing={2} justifyContent="center">
      {
        !!recommended &&
        <RecommendedChecks data={data} setCheck={setCheck} />
      }
      {
        !recommended &&
        <NotRecommendedChecks data={data} setCheck={setCheck} />
      }

      {
        data.other && (
          <Grid item xs={12}>
            <TextField
              label={<FormattedMessage id="conversation.review.specifyother" defaultMessage="Please specify the other reason" />}
              margin="dense"
              name="extra"
              type="text"
              value={data.extra || ''}
              onChange={setExtra}
              fullWidth
              rows="3"
              multiline
              variant="outlined"
            />
          </Grid>
        )
      }
      <Grid item xs={12}>
        <hr />
        <Button
          fullWidth
          onClick={() => {
            const { extra, other, ...rest } = data;

            onSubmit({
              extra: other ? extra : null,
              details: rest,
            }, true);
          }}
          type="button"
          color="primary"
          variant="contained"
        >
          <FormattedMessage id="conversation.review.save" defaultMessage="Done" />
        </Button>
      </Grid>
    </Grid>
  );
};

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    recommended: PropTypes.bool,
    details: PropTypes.shape({
      fast: PropTypes.bool,
      friendly: PropTypes.bool,
      slow: PropTypes.bool,
      calendar_outdated: PropTypes.bool,
      price_outdated: PropTypes.bool,
    }),
    other: PropTypes.bool,
    extra: PropTypes.string,
  }),
};

export default Form;
